import { useDebugValue, useRef } from "react";
import isEqual from "lodash/isEqual";
import useMountedRef from "./useMountedRef";
function useMemoizedValue(value) {
  var compare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isEqual;
  var resultRef = useRef(value);
  var mountedRef = useMountedRef();
  if (mountedRef.current) {
    if (!compare(resultRef.current, value)) {
      resultRef.current = value;
    }
  }
  useDebugValue(resultRef.current === value ? "Latest" : "Previous");
  return resultRef.current;
}
export default useMemoizedValue;